import { getNode } from '../Nodes';
import { getCompressedJson } from '../../../API/Export/ExportApi';
import { publishApplication } from '../Launch';
import { callApiWithAuthorization } from '../../../API/CallApi';
import { getProject } from '../../../API/Project/project';

export async function getEntityPages(entityId) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/nodes/${entityId}/pages`);
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function getPageTarget(pageId) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/page/${pageId}/targetPages`);
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function getReferenceComponentTargets(pageId, entityId) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/page/${pageId}/referenceTargetPages?entityId=` + entityId);
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function getParentComponent(componentId) {
	try {
		const request = await callApiWithAuthorization("/api/v0/component/" + componentId + "/parentComponent");
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function pastePageWithoutConfig(pageId, pageName) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/page/${pageId}/cloneWithoutConfig`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				pageId, pageName
			})
		});
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function pastePageWithConfig(pageId, pageName, copyTarget = true) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/page/${pageId}/cloneWithConfig`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				pageId, pageName, copyTarget
			})
		});
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function deleteFolder(folderId) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/folder/${folderId}`, {
			method: "DELETE",
			headers: {
				"Content-Type": "application/json"
			}
		});
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function deletePage(pageId) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/page/${pageId}`, {
			method: "DELETE",
			headers: {
				"Content-Type": "application/json"
			}
		});
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function publishApp(publishData, doFullPublish = false) {
	try {
		debugger;
		const { projectId, organisationId, instanceId, context, pageId, subPageType, entityId, userId, organisationName } = publishData;
		let projectPublishUrl = process.env.REACT_APP_RUNTIME_API_URL + "/api/ui/IncrementalPublish";
		const projectData = await getProject(projectId);
		const instance = projectData.instances.find(instance => instance.instanceType === "Production");

		let compressedJson, json;

		// if (
		// 	projectData.hasSchemaChanges === true ||
		// 	subPageType === "New Record" ||
		// 	subPageType === "Edit Record" ||
		// 	doFullPublish
		// ) {
		// 	let forPreview = instance["instanceType"] === "Production" ? false : true
		// 	compressedJson = await getCompressedJson(
		// 		projectId,
		// 		organisationId,
		// 		userId,
		// 		instanceId,
		// 		forPreview,
		// 		false
		// 	);
		// 	const publishResponse = await LaunchApplication(compressedJson, instance, context);
		// 	if (publishResponse.status === "Failure") {
		// 		throw new Error(publishResponse.message);
		// 	}
		// 	return [publishResponse, null];
		// } else {
		const [jsonResponse, jsonError] = await getIncrementalPublishJson({
			organisationId,
			organisationName,
			projectId,
			instanceId: instance._id,
			pageId,
			entityId
		});

		if (jsonError) {
			throw (jsonError);
		}
		const { data: jsonData } = jsonResponse;

		//console.log(JSON.stringify(json));

		let token = localStorage.getItem("accessToken");

		const headers = {
			"Content-Type": "application/json",
			"Authorization": "Bearer " + token,
			"appid": instance._id
		}

		const publishRequest = await fetch(projectPublishUrl, {
			method: "post",
			headers: headers,
			body: JSON.stringify(jsonData)
		});

		const publishResponse = await publishRequest.json();
		if (publishResponse.status === "Failure") {
			throw new Error(publishResponse.message);
		}
		return [publishResponse, null];
		// }
	} catch (err) {
		return [null, err.message];
	}
}

async function LaunchApplication(compressJson, instance, context, isFirstTimePublish = false) {
	console.time("runtime");
	let result = await publishApplication(
		context,
		instance,
		compressJson,
		isFirstTimePublish
	);
	return result
};

export async function getIncrementalPublishJson(publishData) {
	try {
		const { pageId } = publishData;
		const request = await callApiWithAuthorization("/api/v0/page/" + pageId + "/publish", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(publishData)
		});
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function changeComponentParent(componentId, parentId) {
	try {
		const request = await callApiWithAuthorization(
			"/api/v0/component/" + componentId + "/changeParent",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					componentId,
					parentId,
				}),
			}
		);
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function checkIfPageIsSyncedToForm(entityId, pageId) {
	const request = await callApiWithAuthorization(`/api/v0/entity/${entityId}/page/${pageId}/synced-to-form`);
	const response = await request.json();
	return response;
}